export const optionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false
      }
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
        boxWidth: 20, 
        font: {
          size: 14, 
          weight: 'normal',
          family:'Poppins',
        },
      },
    },
    title: {
      display: true,
      text: 'Trip Analytics',
      align: 'start',
      font: {
        size: 16, 
        weight: 600,
        family:'Poppins',
      },
      padding:{
        bottom:30
      },
      color: '#282828',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const dataBar = {
  labels,
  datasets: [
    {
      label: 'Ride',
      data: [700, 500, 600, 150, 800, 200],
      backgroundColor: '#FFA726',
    },
    {
      label: 'Rental',
      data: [300, 600, 500, 350, 200, 250],
      backgroundColor: '#0f538d',

    },
  ],
};

export const dataDoughnut = {
  labels: ['Ride', 'Rental', 'Others'],
  datasets: [
    {
      label:'Count',
      data: [100, 350, 50],
      backgroundColor: ['#0f538d', '#ffa726', '#969696'],
    },
  ],
};
export const semiDataDoughnut = {
  labels: ['SUV', 'Sedan', 'Hatchback'],
  datasets: [
    {
      label:'Count',
      data: [140, 120, 80],
      backgroundColor: ['#0f538d', '#ffa726', '#969696'],
    },
  ],
};

export const optionsDoughnutCab = {
  responsive: true,
  maintainAspectRatio: false,
  cutout:'75%',
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
        boxWidth: 20, 
        font: {
          size: 14, 
          weight: 'normal',
          family:'Poppins',
        },
      },
    },
    title: {
      display: true,
      text: 'Total Trips',
      align: 'start',
      font: {
        size: 16,
        weight: 600,
        family:'Poppins',
      },
      color:'#282828',
    },
  },
};

export const semiOptionsDoughnutCab = {
  responsive: true,
  maintainAspectRatio: false,
  cutout:'60%',
  rotation:-90,
  circumference:180,
  layout: {
    padding: { bottom: 8 },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 12,
        boxWidth: 20,
        font: {
          size: 14, 
          weight: 'normal',
          family:'Poppins',
        },
      },
    },
    title: {
      display: true,
      text: 'Our Vehicle',
      align: 'start',
      font: {
        size: 16,
        weight: 600,
        family:'Poppins',
      },
      color:'#282828',
    },
  },
};

export const dataDoughnutCustomer = {
  labels: ['Female', 'Male'],
  datasets: [
    {
      label:'Count',
      data: [2986, 1000],
      backgroundColor: ['#6665DD', '#34D19E'],
    },
  ],
};

export const optionsDoughnutCustomer = {
  responsive: true,
  maintainAspectRatio: false,
  cutout:'75%',
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        padding: 20,
        boxWidth: 20, 
        font: {
          size: 14, 
          weight: 'normal',
          family:'Poppins',
        },
      },
    },
    title: {
      display: true,
      text: 'Our Riders',
      align: 'start',
      font: {
        size: 16,
        weight: 600,
        family:'Poppins',
      },
      color:'#282828',
    },
  },
};